// extracted by mini-css-extract-plugin
export var banner = "_gw-0";
export var closeButton = "_gw-2";
export var greenCheckmark = "_gw-3";
export var hereLink = "_gw-4";
export var titleIcon = "_gw-1";